import { HttpClient } from '@angular/common/http';


/**------------------------------------------------------
 * Dependency Injection Helpers
 */
export abstract class AbstractSecureHttpClient extends HttpClient {}
